import React, { useState } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import AdminModal from '../Admin/AdminModal'

export default function DownloadCodeModal({ open, file, grantId, onClose }) {
  const [code, setCode] = useState('')
  const [downloading, setDownloading] = useState(false)

  const handleClose = () => {
    if (downloading) return
    setCode('')
    onClose()
  }

  const handleDownload = async (e) => {
    e.preventDefault()
    if (!file?.id || !grantId) return
    setDownloading(true)
    try {
      const res = await axios.post(
        `/api/share-packages/grants/${grantId}/files/${file.id}/download`,
        { accessCode: code.trim() },
        { responseType: 'blob' }
      )
      const blobUrl = window.URL.createObjectURL(res.data)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = file.name || 'download'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
      toast.success(`Downloaded ${file.name}`)
      handleClose()
    } catch (err) {
      const msg = err.response?.data?.message || 'Download failed'
      toast.error(msg)
    } finally {
      setDownloading(false)
    }
  }

  return (
    <AdminModal
      open={open}
      title="Enter Download Code"
      subtitle={file?.name}
      onClose={handleClose}
      footer={(
        <>
          <button type="button" className="admin-btn secondary" disabled={downloading} onClick={handleClose}>Cancel</button>
          <button type="submit" form="download-code-form" className="admin-btn primary" disabled={downloading}>
            {downloading ? 'Downloading…' : 'Download'}
          </button>
        </>
      )}
    >
      <form id="download-code-form" onSubmit={handleDownload}>
        <p style={{ fontSize: 13, color: '#606266', marginBottom: 12 }}>
          Use the download code sent to your registered email. Viewing files does not require a code.
        </p>
        <input
          className="admin-field-input"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="6-character code"
          maxLength={12}
          autoComplete="off"
          required
        />
      </form>
    </AdminModal>
  )
}
